/**
 * Stable error codes for the centralized error handler.
 * Used for notifications, Sentry grouping, and support reporting.
 * Prefix APP_ keeps them distinct from backend/API error codes.
 */
export enum AppErrorCodeEnum {
  CannotUnlockMultiplePasswordProtected = 'APP_CANNOT_UNLOCK_MULTIPLE_PASSWORD_PROTECTED',
  DashboardInvalidFilter = 'APP_DASHBOARD_INVALID_FILTER',
  DashboardPdfExportFailed = 'APP_DASHBOARD_PDF_EXPORT_FAILED',
  DashboardRecipientNotFound = 'APP_DASHBOARD_RECIPIENT_NOT_FOUND',
  DashboardReportAccessDenied = 'APP_DASHBOARD_REPORT_ACCESS_DENIED',
  DashboardReportFetchFailed = 'APP_DASHBOARD_REPORT_FETCH_FAILED',
  DashboardReportServerError = 'APP_DASHBOARD_REPORT_SERVER_ERROR',
  FilesFetchGeneric = 'APP_FILES_FETCH_GENERIC',
  FilesFetchPasswordLockout = 'APP_FILES_FETCH_PASSWORD_LOCKOUT',
  SessionExpired = 'APP_SESSION_EXPIRED',
  TransferOwnershipFailed = 'APP_TRANSFER_OWNERSHIP_FAILED',
}
